import { createSelector } from 'reselect'
import cartSelector from './cartSelector'

const cartRemarksSelector = createSelector(
    cartSelector,
    (cart): CartRemarks => cart.remarks,
)

export default cartRemarksSelector
